@if (selectedRow) {
  <app-sublease-request-form
    [subleaseRequest]="selectedRow"
    (completed)="onCompleted($event)"
  ></app-sublease-request-form>
}
@if (!selectedRow) {
  <div>
    <div class="sublease-requests__create-action">
      <astral-button variant="primary" type="button" icon="plus" labelKey="CREATE_BTN" (click)="createItem()"></astral-button>
    </div>
    <app-list-view
      [columnDefinition]="columnDefinition"
      [contextMenuDefinition]="menuDefinition"
      [itemsSource]="itemsSource"
      [preferencesKey]="'rent.sublease-requests.list'"
      (rowClick)="onRowClicked($event)"
    ></app-list-view>
  </div>
}
